import React from 'react';

/** Import Components **/
import { withStyles } from '@mui/styles';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const propTypes = {
    color: PropTypes.string,
};

const defaultProps = {
    color: 'white',
    height: '100%',
    width: '100%',
};

function InelioIcon(props) {
    const StyledSvgIcon = withStyles(theme => ({
        root: {
            height: props.height,
            width: props.width,
        },
    }))(SvgIcon);

    return (
        <StyledSvgIcon
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 374.71 137.83"
            width={props.width}
            height={props.height}
            {...props}>
            <g>
                <path
                    d="M2.89 4.74h5.36a2.89 2.89 0 012.89 2.89v105.79a2.89 2.89 0 01-2.89 2.89H2.89A2.89 2.89 0 010 113.42V7.63a2.89 2.89 0 012.89-2.89M106.76 66.72a36 36 0 00-71.92 0v46.7a2.89 2.89 0 002.89 2.89h4.92a2.89 2.89 0 002.89-2.89l-.05-46.7a25.32 25.32 0 0150.63 0v46.7a2.89 2.89 0 002.88 2.89h4.91a2.89 2.89 0 002.89-2.89zM230.49 2h4.91a2.88 2.88 0 012.88 2.89v108.68a2.88 2.88 0 01-2.88 2.89h-4.91a2.89 2.89 0 01-2.89-2.89V4.92A2.89 2.89 0 01230.49 2M261.56 33.93h4.83a2.89 2.89 0 012.89 2.89v76.76a2.88 2.88 0 01-2.89 2.88h-4.83a2.89 2.89 0 01-2.89-2.88V36.82a2.89 2.89 0 012.89-2.89M263.94 0a8.52 8.52 0 016.21 2.56 8.33 8.33 0 012.59 6.17 8.45 8.45 0 01-2.59 6.2 8.48 8.48 0 01-6.21 2.6 8.36 8.36 0 01-6.17-2.6 8.5 8.5 0 01-2.56-6.2 8.38 8.38 0 012.56-6.17A8.4 8.4 0 01263.94 0M200.49 69.18h-65.43c.05-.28.09-.56.14-.85v-.15c.07-.36.15-.72.23-1.08 0-.16.06-.31.1-.47s.13-.5.19-.75l.21-.78c0-.15.09-.29.13-.43.11-.36.22-.72.34-1.08 0-.05 0-.09.05-.13a33.25 33.25 0 014.79-9.11l.24-.32c.19-.25.38-.49.58-.73s.48-.59.73-.87l.16-.19a32.91 32.91 0 015-4.55c.6-.45 1.21-.88 1.83-1.28l.28-.18c.69-.44 1.38-.84 2.09-1.22l.26-.14a33.43 33.43 0 014.45-1.93l.3-.1a33 33 0 014.62-1.2h.29a33.24 33.24 0 014.76-.48h.95a32.93 32.93 0 0116.86 4.61l.16.08a33.1 33.1 0 0115.71 23.4m4-18.69a43.22 43.22 0 00-13.32-13.17l-.39-.23-.62-.38a43.35 43.35 0 00-21.68-6.16H165.32c-.61 0-1.22.08-1.83.14a43 43 0 00-14.46 4 43.64 43.64 0 00-14 10.58l-.08.08c-.44.51-.87 1-1.29 1.55l-.19.23c-.37.48-.74 1-1.09 1.46L132 49c-.31.45-.62.9-.91 1.37-.12.17-.24.34-.35.52-.26.43-.52.85-.77 1.29-.13.21-.25.43-.38.65-.22.4-.44.81-.65 1.22l-.39.76c-.19.39-.37.78-.55 1.17s-.26.56-.38.85-.14.3-.2.45c-.14.34-.28.69-.41 1 0 .13-.11.27-.16.41a42.67 42.67 0 00-2.62 11.08v.19c0 .3-.07.6-.09.9v5.38c0 .32 0 .64.07 1s0 .85.09 1.28l.09.83c.06.47.12 1 .19 1.43 0 .22.07.44.11.66.08.53.18 1.07.29 1.6 0 .16.06.31.1.47.13.6.26 1.19.42 1.78 0 .1 0 .19.07.28.18.66.37 1.31.57 2v.1a43.85 43.85 0 007.15 13.56 43.26 43.26 0 0012.72 11l.24.14 1.28.69.94.47.38.19a43.66 43.66 0 0031.86 2.28l.67-.22.91-.31 1.15-.43.33-.12a43.21 43.21 0 006.2-3l.59-.38 1.42-.91h.05a43.44 43.44 0 0015.61-18.46 2.91 2.91 0 00-2.07-4l-4.83-1a2.91 2.91 0 00-3.18 1.59 33 33 0 01-11.5 13.16l-.95.6q-.87.54-1.77 1l-.18.1c-.67.35-1.35.68-2 1l-.42.18a33.52 33.52 0 01-4.46 1.54l-.25.06a33.84 33.84 0 01-5 .88 32.71 32.71 0 01-5.34.09c-1-.06-2-.17-2.92-.31h-.25l-1.25-.23-.29-.06a32.71 32.71 0 01-9.41-3.57l-.75-.44a33.42 33.42 0 01-15.33-21.08c-.18-.78-.32-1.57-.43-2.35h73.74v-.35a2.89 2.89 0 002.65-2.75 43.56 43.56 0 00-6.93-25.61M341 31.66v11a33.13 33.13 0 11-20 0v-11a43.73 43.73 0 1020 0"
                    fill={props.color}
                />
                <path
                    d="M331.16 134.6a2.5 2.5 0 002.21-1.29 2.6 2.6 0 00.34-1.3 2.58 2.58 0 00-.35-1.31 2.44 2.44 0 00-.94-1 2.52 2.52 0 00-1.25-.34 2.64 2.64 0 00-1.29.34 2.36 2.36 0 00-.94.94 2.63 2.63 0 00-.33 1.31 2.59 2.59 0 00.74 1.88 2.42 2.42 0 001.81.74m-2.68-.46a4.39 4.39 0 01-.63-1.73v-6.09h.82v3.59a3.46 3.46 0 011.16-1 3.21 3.21 0 011.42-.31 3.15 3.15 0 012.33 1 3.34 3.34 0 011 2.41 3.26 3.26 0 01-1 2.37 3.17 3.17 0 01-2.34 1 3.51 3.51 0 01-1.48-.31 3.62 3.62 0 01-1.27-1"
                    fill="#1d1d1b"
                />
                <path
                    d="M331.16 134.6a2.5 2.5 0 002.21-1.29 2.6 2.6 0 00.34-1.3 2.58 2.58 0 00-.35-1.31 2.44 2.44 0 00-.94-1 2.52 2.52 0 00-1.25-.34 2.64 2.64 0 00-1.29.34 2.36 2.36 0 00-.94.94 2.63 2.63 0 00-.33 1.31 2.59 2.59 0 00.74 1.88 2.42 2.42 0 001.81.77zm-2.68-.46a4.39 4.39 0 01-.63-1.73v-6.09h.82v3.59a3.46 3.46 0 011.16-1 3.21 3.21 0 011.42-.31 3.15 3.15 0 012.33 1 3.34 3.34 0 011 2.41 3.26 3.26 0 01-1 2.37 3.17 3.17 0 01-2.34 1 3.51 3.51 0 01-1.48-.31 3.62 3.62 0 01-1.28-.93z"
                    fill={props.color}
                    stroke={props.color}
                    strokeMiterlimit={10}
                    strokeWidth={0.5}
                />
                <path
                    fill="#1d1d1b"
                    d="M335.51 128.8h.88l2.21 4.96 2.15-4.96h.88l-3.84 8.79h-.87l1.23-2.84-2.64-5.95z"
                />
                <path
                    fill={props.color}
                    stroke={props.color}
                    strokeMiterlimit={10}
                    strokeWidth={0.5}
                    d="M335.51 128.8h.88l2.21 4.96 2.15-4.96h.88l-3.84 8.79h-.87l1.23-2.84-2.64-5.95z"
                />
                <path fill="#1d1d1b" d="M346.49 122.91h6.79v1.22h-5.56v3.85h3.29v1.21h-3.29v6.05h-1.23v-12.33z" />
                <path
                    fill={props.color}
                    stroke={props.color}
                    strokeMiterlimit={10}
                    strokeWidth={0.5}
                    d="M346.49 122.91h6.79v1.22h-5.56v3.85h3.29v1.21h-3.29v6.05h-1.23v-12.33z"
                />
                <path
                    fill="#1d1d1b"
                    d="M355.57 122.91h1.24v5.17h6.27v-5.17h1.23v12.33h-1.23v-5.95h-6.27v5.95h-1.24v-12.33z"
                />
                <path
                    fill={props.color}
                    stroke={props.color}
                    strokeMiterlimit={10}
                    strokeWidth={0.5}
                    d="M355.57 122.91h1.24v5.17h6.27v-5.17h1.23v12.33h-1.23v-5.95h-6.27v5.95h-1.24v-12.33z"
                />
                <path
                    fill="#1d1d1b"
                    d="M367.29 122.91v12.33h7.01v-1.23h-5.78v-4.83h3.55v-1.2h-3.55v-3.85h5.83v-1.22h-7.06z"
                />
                <path
                    fill={props.color}
                    stroke={props.color}
                    strokeMiterlimit={10}
                    strokeWidth={0.5}
                    d="M367.29 122.91h7.06v1.22h-5.83v3.85h3.55v1.2h-3.55v4.83h5.78v1.23h-7.01v-12.33z"
                />
                <path
                    d="M335 45.38a4 4 0 11-8 0V25.81a4 4 0 118 0zm4-19.72h-1a7 7 0 00-14 0h-1a1.51 1.51 0 000 3h1v16.72a7 7 0 0014 0V28.67h1a1.51 1.51 0 000-3"
                    fill={props.color}
                />
                <path d="M327 45.38a4 4 0 108 0V28.76h-8z" fill="#17998b" />
            </g>
        </StyledSvgIcon>
    );
}

InelioIcon.propTypes = propTypes;
InelioIcon.defaultProps = defaultProps;

export default InelioIcon;
